<script setup lang="ts">
import { EntityListPage, type EntityConfig } from '@botto/core';
import { countriesStore } from '../api';
import type { Country } from '../api';

const config: EntityConfig<Country> = {
  title: 'Страна',
  titlePlural: 'Страны',
  popupWidth: 520,
  columns: [
    { dataField: 'id', caption: 'ID', dataType: 'number', width: 80 },
    { dataField: 'country', caption: 'Страна' },
    { dataField: 'country_iso', caption: 'ISO', width: 80 },
    { dataField: 'mcc', caption: 'MCC', width: 100 },
    { dataField: 'description', caption: 'Описание' },
  ],
  fields: [
    { dataField: 'id', label: 'ID', editOnly: true, editorOptions: { readOnly: true } },
    { dataField: 'country', label: 'Страна', required: true },
    { dataField: 'country_iso', label: 'ISO-код', required: true },
    { dataField: 'mcc', label: 'MCC', required: true },
    { dataField: 'description', label: 'Описание', editorType: 'dxTextArea' },
  ],
};
</script>

<template>
  <EntityListPage :config="config" :store="countriesStore" />
</template>
